import useFetchObjects from "../../api/useFetchObjects";

const useLatestTitles = () => {
  // Get token from localStorage
  const token = localStorage.getItem("token");

  return useFetchObjects(
    ["latest-titles"],
    "books/latest_titles/",
    token ? token : null,
    { refetchOnWindowFocus: false },
  );
};

export default useLatestTitles;
